import axios from "axios";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

export function useGetStates() {
  const { data, isLoading } = useQuery(
    ["states"],
    () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/misc/states`)
        .then((response) => {
          return response.data;
        }),
    {
      refetchOnWindowFocus: false,
    }
  );

  return {
    loading: isLoading,
    states: data,
  };
}

export function useGetLGA() {
  const [stateID, setStateID] = useState("");
  const { data, isLoading } = useQuery(
    ["LGA", stateID],
    (data) => {
      return axios
        .get(`${process.env.REACT_APP_BASE_URL}/misc/lga/${data.queryKey[1]}`)
        .then((response) => {
          return response.data;
        });
    },
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(stateID)
    }
  );

  return {
    loading: isLoading,
    LGA: data,
    setStateID,
  };
}

export function useGetCities() {
  const [stateID, setStateID] = useState("");

  const { data, isLoading } = useQuery(
    ["cities", stateID],
    (data) => {
      return axios
        .get(`${process.env.REACT_APP_BASE_URL}/misc/city/${data.queryKey[1]}`)
        .then((response) => {
          return response.data;
        });
    },
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(stateID)
    }
  );

  return {
    loading: isLoading,
    cities: data,
    setStateID,
  };
}
